import {createApi} from '@reduxjs/toolkit/query/react'
import {baseQuery} from "../baseQuery";

const refetchSeconds = process.env.REACT_APP_REFETCH_SECONDS ? parseInt(process.env.REACT_APP_REFETCH_SECONDS) : 30;

export const feedbackApi = createApi({
    reducerPath: 'feedbackApi',
    baseQuery,
    tagTypes: ["feedback"],
    keepUnusedDataFor: 300,
    refetchOnMountOrArgChange: refetchSeconds,
    endpoints: (builder) => ({
        sendFeedback: builder.mutation({
            query: (body) => ({
                url: `feedback/process`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ["feedback"]
        }),
        getAllFeedback: builder.query({
            query: () => `feedback`,
            providesTags: ["feedback"]
        }),
        deleteFeedback: builder.mutation<any, any>({
            query: ({id}) => ({
                url: `feedback/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ["feedback"],
        }),
    })
});

export const {
    useSendFeedbackMutation,
    useLazyGetAllFeedbackQuery,
    useDeleteFeedbackMutation
} = feedbackApi;
